import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlertFlashDataService } from './alert-flash-data.service';
import { ALERT_FLASH_NAME } from './alert-flash-name';
import { CommonModule } from '@angular/common';
import { I18NService } from '../../core/i18n/i18n.service';

@Component({
    selector: 'adminui-alert-flash',
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './alert-flash.component.html'
})
export class AlertFlashComponent implements OnInit {

  readonly alertFlashName = input.required<string>();

  readonly alertClass = signal('');
  readonly text = signal('');
  readonly show = signal(false);
  alertPrefix = 'toast-';
  iconPrefix = 'vismaicon-'

  alertFlashNameConst = ALERT_FLASH_NAME;

  private readonly alertFlashDataService = inject(AlertFlashDataService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly i18n = inject(I18NService);

  /**
   * The heading and the close button's name, from the locale files - they were hardcoded English.
   * The English fallbacks only cover an alert raised before the translations have loaded.
   */
  get title(): string {
    const common = this.i18n.messages['common'];
    switch (this.alertClass()) {
      case 'toast-success': return common?.['alertTitleSuccess'] ?? 'Success';
      case 'toast-warning': return common?.['alertTitleWarning'] ?? 'Warning';
      default: return common?.['alertTitleInformation'] ?? 'Information';
    }
  }

  get closeLabel(): string {
    return this.i18n.messages['common']?.['ariaLabelClose'] ?? 'Close';
  }

  ngOnInit(): void {
    this.alertFlashDataService.alertMessage$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(alertFlashMessage => {
        if (alertFlashMessage.alertFlashName === this.alertFlashName()) {
          if (alertFlashMessage.type !== '' && alertFlashMessage.text !== '') {
            this.alertClass.set(`toast-${alertFlashMessage.type}`);
            this.text.set(alertFlashMessage.text);
            this.show.set(true);
          } else {
            this.show.set(false);
          }
        }
      });
  }

  close() {
    this.show.set(false);
    this.alertFlashDataService.reset();
  }
}
